var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsideLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88889 1.38889C8.88889 0.897969 9.28686 0.5 9.77778 0.5H15.1111C15.602 0.5 16 0.897969 16 1.38889V6.72222C16 7.21314 15.602 7.61111 15.1111 7.61111C14.6202 7.61111 14.2222 7.21314 14.2222 6.72222V3.53486L6.85076 10.9063C6.50363 11.2535 5.94082 11.2535 5.59368 10.9063C5.24655 10.5592 5.24655 9.99637 5.59368 9.64924L12.9651 2.27778H9.77778C9.28686 2.27778 8.88889 1.87981 8.88889 1.38889ZM0 4.94444C0 4.45352 0.397969 4.05556 0.888889 4.05556H6.47619C6.96711 4.05556 7.36508 4.45352 7.36508 4.94444C7.36508 5.43536 6.96711 5.83333 6.47619 5.83333H1.77778V14.7222H10.6667V10.0238C10.6667 9.53289 11.0646 9.13492 11.5556 9.13492C12.0465 9.13492 12.4444 9.53289 12.4444 10.0238V15.6111C12.4444 16.102 12.0465 16.5 11.5556 16.5H0.888889C0.397969 16.5 0 16.102 0 15.6111V4.94444Z",
    fill: "#ff6633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideLinkIcon);
export default __webpack_public_path__ + "static/media/outside-link-icon.05b1e72c6d288b7f0e69ae5204f01b8e.svg";
export { ForwardRef as ReactComponent };